import { config } from "../config";

export type GarminAccountDetails = {
  garminUserId: string;
  linkedAt: string;
  lastUpdatedAt: string;
};

export type AuthUserDetails = {
  email?: string | null;
  name?: string | null;
};

export type AuthCheckResult = {
  ok: boolean;
  authenticated: boolean;
  connected: boolean;
  admin: boolean;
  user?: AuthUserDetails;
  account?: GarminAccountDetails;
  error?: string;
};

export const authCheck = async (): Promise<AuthCheckResult> => {
  try {
    const response = await fetch(`${config.REACT_APP_API_BASE_URL}/auth/check`, {
      credentials: "include",
    });

    if (response.status === 401 || response.status === 403) {
      return {
        ok: true,
        authenticated: false,
        connected: false,
        admin: false,
      };
    }

    if (!response.ok) {
      return {
        ok: false,
        authenticated: false,
        connected: false,
        admin: false,
        error: `Auth check failed (${response.status})`,
      };
    }

    const data = await response.json();
    return {
      ok: true,
      // Keep older API/mock responses with connected=true usable while the
      // Workers API rolls out the explicit authenticated field.
      authenticated: Boolean(data?.authenticated ?? data?.connected),
      connected: Boolean(data?.connected),
      admin: Boolean(data?.admin),
      user: data?.user,
      account: data?.account,
    };
  } catch {
    return {
      ok: false,
      authenticated: false,
      connected: false,
      admin: false,
      error: "We couldn't verify your LaceAI session right now. Please check your network and try again.",
    };
  }
};
